import React from 'react'

export default () => (
  <svg
    width="auto"
    height="100%"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_176_1669)">
      <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9.5C18 14.4706 13.9706 18.5 9 18.5C4.02944 18.5 0 14.4706 0 9.5C0 4.52944 4.02944 0.5 9 0.5C13.9706 0.5 18 4.52944 18 9.5ZM15.75 9.49998L11.9867 5.75V8.4963L8.25 11.246L11.9867 11.2486V13.25L15.75 9.49998ZM6.01333 13.25L2.25 9.5L6.01333 5.75V7.7514L9.75 7.75394L6.01333 10.5258V13.25Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_176_1669">
        <rect y="0.5" width="18" height="18" rx="9" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
